/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import { Icons } from '../../../Constants/Icons';

export enum FilterType {
  All = 'All',
  NoShow = 'NoShow',
  InProgress = 'InProgress',
  Completed = 'Completed',
  PendingReview = 'PendingReview',
  Approved = 'Approved',
  NoJob = 'NoJob',
  Scheduled = 'Scheduled',
}

export const STATUS_MARKER_ICONS: Partial<Record<FilterType, string>> = {
  [FilterType.Scheduled]: Icons.PendingReviewsMapIcon,
  [FilterType.NoShow]: Icons.NoShowMapIcon,
  [FilterType.InProgress]: Icons.InprogressMapIcon,
  [FilterType.Completed]: Icons.ApprovedCustomerMap,
  [FilterType.NoJob]: Icons.InCompleteMapIcon,
};
export const STATUS_MARKER_ICON_PX = 32; // Marker's 2rem
export const FACILITY_MARKER_ICON_PX = 25;

// Zoom used to show one facility, close enough to pick it out; also the closest the map zooms to a group of them.
export const SINGLE_FACILITY_ZOOM = 15;
// Size (degrees, about 100 km) of the areas facilities are grouped into to find where most of them are.
export const BUSIEST_AREA_CELL_DEGREES = 1;
// Space (px) kept between the busiest area's facilities and the map's edges.
export const BUSIEST_AREA_PADDING = 48;

export type MapPosition = { latitude: number; longitude: number };
